
import { useNavigate } from "react-router-dom";
import Container from "../../../Components/Cards/Information/container";
import MobileCarousel from "../../../Components/Cards/Information/MobileCarousel";
import { useState, useEffect } from "react";
import { API_BASE_URL } from "../../../config/api";

export default function InviteInfoCard() {
  const navigate = useNavigate();
  const [referalData, setReferalData] = useState(null);
  const [accLoading, setAccLoading] = useState(true);
  const fetchReferalData = async () => {
    try {
      let response = await fetch(`${API_BASE_URL}auth/trader/referral-stats/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      });

      // If access token is invalid/expired → try to refresh
      if (response.status === 401) {
        try {
          const refreshResponse = await fetch(
            `${API_BASE_URL}auth/trader/jwt/refresh/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                refresh: localStorage.getItem("refresh"),
              }),
            },
          );

          if (!refreshResponse.ok) {
            // refresh failed → log out and redirect
            localStorage.removeItem("access");
            localStorage.removeItem("authCredentials");
            localStorage.removeItem("refresh");
            localStorage.removeItem("role");
            localStorage.removeItem("email");
            navigate("/signin");
            return; // ⬅️ IMPORTANT: stop here
          }

          const refreshData = await refreshResponse.json();
          localStorage.setItem("access", refreshData.access);

          // retry original request with new access token
          response = await fetch(`${API_BASE_URL}auth/trader/referral-stats/`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          });
        } catch (err) {
          console.error("Error refreshing token:", err);
          return;
        }
      }

      // handle final response (original or retried)
      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setReferalData(data);
      setAccLoading(false);
    } catch (error) {
      setAccLoading(false);
      console.error("Error fetching account data:", error);
    }
  };
  useEffect(() => {
    fetchReferalData();
  }, []);
  return (
    <div className="w-full p-5 flex flex-col gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <div className="w-full flex items-center justify-between">
        <h3 className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
          اطلاعات دعوت از دوستان
        </h3>
      </div>

      <MobileCarousel>
        <Container
          color="yellow"
          width="300px"
          className=""
          accLoading={accLoading}
          title="کد دعوت از دوستان"
          value={referalData?.referral_code || "-"}
          svgName="message"
          svgClassName=""
          data="copy"
        />
        <Container
          color="blue"
          width="300px"
          className=""
          accLoading={accLoading}
          title="لینک دعوت از دوستان"
          value={
            referalData?.referral_code
              ? `https://app.cogitofund.com/signup?ref=${referalData.referral_code}`
              : "-"
          }
          valueFontSize="sm"
          valueClassName="w-44 overflow-x-auto text-left whitespace-nowrap [direction:ltr]"
          svgName="hyperlink"
          svgClassName=""
          data="copy"
        />
        <Container
          color="green"
          width="300px"
          className=""
          accLoading={accLoading}
          title="تعداد دوستان دعوت شده"
          value={`${referalData?.referrals_count ? referalData.referrals_count : referalData?.referrals_count === 0 ? "0" : "-"}`}
          svgName="friend"
          svgClassName=""
        />
      </MobileCarousel>
    </div>
  );
}
